export default "__VITE_ASSET___ViEud_I__"